// extracted by mini-css-extract-plugin
export default {"wrapper":"AvatarFallback_wrapper__X8jpN"};